import { filterEmptyParams } from '@utils/filterEmptyParams';
import { IPagination, IFilterRequest } from './getEquipments';

/**
 * # Note
 * The function filters the query params for undefined before returning the object,
 *  so properties actually do not exist if they don't
 */
export function makeParamsObject(
  pagination: IPagination | undefined,
  filter: IFilterRequest | undefined,
): Partial<InventoryQueryParams> {
  let search = pagination?.search ? pagination.search : '';
  const manufactorNames = filter?.manufactorNames ?? [];
  const {
    modelNames = [],
    tagNames = [],
    statusId = [],
    usersId = [],
    purchasedDateStart,
    purchasedDateEnd,
  } = filter || {};
  manufactorNames.forEach(name => {
    // Strip lowercase manufacturer names from string if it exists
    search = search.toLowerCase().replace(` ${name.toLowerCase()} `, '');
  });

  const searchParamsObj = {
    page: String(pagination?.page || 1),
    limit: String(pagination?.limit || 20),
    q: search,
    sort: filter?.sort,
    direction: filter?.direction,
    modelNames: modelNames.join(','),
    manufactorNames: manufactorNames.join(','),
    tagNames: tagNames.join(','),
    statusId: statusId.join(','),
    usersId: usersId.join(','),
    purchasedDateStart:
      purchasedDateStart && new Date(purchasedDateStart).toJSON(),
    purchasedDateEnd: purchasedDateEnd && new Date(purchasedDateEnd).toJSON(),
  };

  const paramsNoEmpty =
    Object.entries(searchParamsObj).filter(filterEmptyParams);
  const readyParamsObj = Object.fromEntries(paramsNoEmpty);
  return readyParamsObj as Partial<InventoryQueryParams>;
}

export interface InventoryQueryParams {
  [x: string]: string;
  page: string;
  limit: string;
  q: string;
  sort: string;
  direction: 'ASC' | 'DESC';
  modelNames: string;
  manufactorNames: string;
  tagNames: string;
  statusId: string;
  usersId: string;
  purchasedDateStart: string;
  purchasedDateEnd: string;
}
export const filterOpts: (keyof InventoryQueryParams)[] = [
  'q',
  'modelNames',
  'manufactorNames',
  'tagNames',
  'statusId',
  'usersId',
  'purchasedDateStart',
  'purchasedDateEnd',
];
